import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Fragment, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import useFavorite from "../../../../hook/useFavorite";

import { useOrder } from "../../../../hook/useOrder";
import Backdrop from "../../../Backdrop";
import InfoIcon from "../../../InfoIcon";
import { AddToCart } from "../../shopping-cart/AddToCart";
import Filter from "./desktop/filter";

export default function DesktopComponent() {
  const [desktopItems, setDesktopItems] = useState();

  let filteredproducts = useSelector((state) => state.product.filteredProducts);

  let stateproducts = useSelector((state) => state.product.products);

  let userOrders = useSelector((state) => state.user.orders);

  useEffect(() => {
    let items = [];
    let products = filteredproducts ?? stateproducts;

    if (products && Object.keys(products).length > 0) {
      products.forEach((product) => {
        const isFree = Number(product.price) === 0;
        let showOrder = isFree;
        let showPaidOrder = !isFree;
        

        if (userOrders) {
          let productOrder = userOrders.filter(
            (order) => order.product_id === product.id,
          );

          showOrder = isFree && productOrder.length === 0;
          showPaidOrder = !isFree && (
            productOrder.length === 0
            || productOrder.every((order) => order.expired || !order.active)
          );

        }

        items.push(
          <DesktopItem
            key={product.id}
            product={product}
            showOrder={showOrder}
            showPaidOrder={showPaidOrder}
          />,
        );
      });
    }
    setDesktopItems(items);
  }, [filteredproducts, stateproducts, userOrders]);

  if (!desktopItems) {
    return <Skeleton count={50} />;
  }

  return (
    <Fragment>
      <Filter>
        <div className="grid-container-4-col">{desktopItems}</div>
      </Filter>
      <Backdrop />
    </Fragment>
  );
}

function DesktopItem(props) {
  const { product, showOrder,showPaidOrder } = props;

  const { addFavorite, removeFavorite, icon, selected } = useFavorite(
    product.id,
  );

  const { addOrder } = useOrder();

  return (
    <div className="card">
      <img
        className="card-img-top"
        src={`${product.image}`}
        alt={product.title}
        style={{ width: "100%", height: "100%" }}
      />
      <div className="card-body">
        <h5 className="card-title">
          {product.title}{" "}
          <InfoIcon
            icon={icon}
            onClick={() => {
              if (selected) {
                removeFavorite();
                return;
              }
              addFavorite();
            }}
            style={{ cursor: "pointer" }}
          />
        </h5>
        <div className="card-text">
          <p>{product.ptype}</p>
          <p>{product.description}</p>
        </div>
        <Link
          className="btn btn-outline-secondary bgnt"
          style={{ width: "100%" }}
          to={`/products/${product.id}`}
          state={{
            product,
          }}
        >
          <InfoIcon icon={faInfoCircle} title="product details, order" />
          Details
        </Link>
        {!showPaidOrder && !showOrder && <div className="alert alert-success mt-3 mb-0">You already have an active order.</div>}
        {showOrder && (
          <button
            className="btn btn-secondary mt-3"
            style={{ width: "100%" }}
            onClick={() => addOrder(product)}
          >
            Order
          </button>
        )}
        {showPaidOrder && <AddToCart product={product} />}
      </div>
    </div>
  );
}
